import Checkbox from '@ui/Table/Checkbox';
import { cx } from 'class-variance-authority';
import { FC, HTMLAttributes, Key } from 'react';
import { useController } from 'react-hook-form';

export type MultipleSelectOption = {
    id: Key;
    label: string;
};

interface Props extends HTMLAttributes<HTMLDivElement> {
    name: string;
    label?: string;
    options: MultipleSelectOption[];
    vertical?: boolean;
}

const FormMultipleSelect: FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({
    options,
    label,
    name,
    vertical,
    className,
    ...props
}) => {
    const {
        field: { value, onChange }
    } = useController({ name });

    const handleSelect = (option: MultipleSelectOption) => {
        const oldValue = (value ?? [])?.filter((value) => options.some((o) => o.id === value));

        if (isSelected(option)) {
            onChange(oldValue.filter((o) => o !== option.id));
        } else {
            onChange([...oldValue, option.id]);
        }
    };

    const isSelected = (option: MultipleSelectOption) => {
        return value?.includes(option.id);
    };

    return (
        <div className={cx(className, 'tw-mt-2')} {...props}>
            {label && <span className="tw-mb-2 tw-mt-2 tw-inline-block">{label}</span>}
            <div
                className={cx(
                    !vertical ? 'tw-flex tw-flex-col' : 'tw-grid tw-grid-cols-3 tw-flex-wrap tw-justify-between'
                )}
            >
                {options?.map((option) => (
                    <div key={option.id} className="tw-flex tw-gap-2">
                        <Checkbox
                            defaultSelected={isSelected(option)}
                            isSelected={isSelected(option)}
                            onChange={() => handleSelect(option)}
                            name={`${name}.${option.id}`}
                        />
                        <label className="tw-text-accents-9">{option.label}</label>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FormMultipleSelect;
